export default __webpack_public_path__ + "static/media/FormsMeasure.9627aefe.svg";